import { render, staticRenderFns } from "./CardsProductsTazas.vue?vue&type=template&id=0bd8dc7a&scoped=true&"
import script from "./CardsProductsTazas.vue?vue&type=script&lang=js&"
export * from "./CardsProductsTazas.vue?vue&type=script&lang=js&"
import style0 from "./CardsProductsTazas.vue?vue&type=style&index=0&id=0bd8dc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd8dc7a",
  null
  
)

export default component.exports